// extracted by mini-css-extract-plugin
export var container = "PricingAndAvailabilitySubForm-module__container___d7ntw";
export var dynamicContainer = "PricingAndAvailabilitySubForm-module__dynamicContainer___a4B-u";
export var large = "1084px";